import { render, staticRenderFns } from "./DestroyAdvertiserModal.vue?vue&type=template&id=40f54bc6"
import script from "./DestroyAdvertiserModal.vue?vue&type=script&lang=js"
export * from "./DestroyAdvertiserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports